import { useEffect, useState } from 'react';
import { ProposalsProps } from 'lib/types'

const ProposalManagementPdf = ({ proposals }: IProps) => {


    const [proposalCalculationData, setProposalCalculationData] = useState(proposals?.calculationData?.data);
    const [proposalSiteDesignData, setProposalSiteDesignData] = useState(proposals?.siteDesignData);
    const [hasArchiving, setHasArchiving] = useState(false)
    const [hasManagementServer, setHasManagementServer] = useState(false)

    const archiving = proposalCalculationData?.archiveDatabase;
    const managementServer = proposalSiteDesignData?.siteDesign?.serverSettings?.hardwareType === 0 ?
        proposalSiteDesignData?.siteDesign?.serverSettings?.genericServerSettings?.addManagementServer :
        proposalSiteDesignData?.siteDesign?.serverSettings?.huskyServerSettings?.addManagementServer;

    useEffect(() => {
        if (proposals) {
            setProposalCalculationData(proposals.calculationData?.data);
            setProposalSiteDesignData(proposals.siteDesignData);
        }

        if (archiving) {
            setHasArchiving(true);
        } else {
            setHasArchiving(false);
        }

        if (managementServer) {
            setHasManagementServer(true);
        } else {
            setHasManagementServer(false);
        }
    }, [proposals, archiving, managementServer]);

    const genericSupportedCamerasValue = proposalSiteDesignData?.siteDesign?.serverSettings?.hardwareType === 0 ?
        proposalSiteDesignData?.siteDesign?.serverSettings?.genericServerSettings?.managementServerSettings?.supportedCameras :
        proposalSiteDesignData?.siteDesign?.serverSettings?.huskyServerSettings?.managementServerSettings?.supportedCameras;

    let totalCamerasNumber = Math.ceil(proposalSiteDesignData?.siteDesign?.cameras?.reduce((sum, camera) => sum + camera?.quantity, 0));

    return (
        <>
            {hasManagementServer && (
                <div className={"px-10 print-page-break" +
                    (hasArchiving ? " mb-12" : "")}>
                    <div className={"msds-text-header-6 py-4" +
                        (hasArchiving && !hasManagementServer ? " mt-12" : "") +
                        (hasManagementServer && !hasArchiving ? " mt-10" : "")}
                    >
                        Management Server
                    </div>
                    {(totalCamerasNumber > 5000 || genericSupportedCamerasValue === 5) && (
                        <div className='row xsd-proposals-pdf'>
                            <div className="col-12">
                                <div className="server-settings__header msds-text-header-3-bold mt-1">Please contact presales for an optimized design.</div>
                            </div>
                        </div>
                    )}
                    {(totalCamerasNumber <= 5000 && genericSupportedCamerasValue < 5) && (
                        <div className='row xsd-proposals-pdf'>
                            <div className="col-4 xsd-proposals-pdf__server-setting-col-wrapper">
                                <div className="xsd-proposals-pdf__server-setting-col">
                                    <div className="server-settings__header msds-text-header-3-bold mt-1">Management Server Specification</div>
                                    <div className="msds-text-body-3 xsd-proposals-pdf__card-info mt-1">
                                        <div>Quantity of servers:</div>
                                        <div>1</div>
                                    </div>
                                    <div className="msds-text-body-3 xsd-proposals-pdf__card-info">
                                        <div>Processor Type:</div>
                                        <div>{proposalCalculationData?.managementServer?.cpuType}</div>
                                    </div>
                                    <div className="msds-text-body-3 xsd-proposals-pdf__card-info">
                                        <div>O/S Application: </div>
                                        <div>{proposalCalculationData?.managementServer?.osDisk}</div>
                                    </div>
                                    <div className="msds-text-body-3 xsd-proposals-pdf__card-info">
                                        <div>Disk Type: </div>
                                        <div>{proposalCalculationData?.managementServer?.diskType}</div>
                                    </div>
                                    <div className="msds-text-body-3 xsd-proposals-pdf__card-info">
                                        <div>RAM: </div>
                                        <div>{proposalCalculationData?.managementServer?.ram}</div>
                                    </div>
                                    <div className="msds-text-body-4-bold xsd-proposals-pdf__card-info">
                                        <div>Max Supported Cameras: </div>
                                        <div>{proposalCalculationData?.managementServer?.maxCameras}</div>
                                    </div>
                                    <div className="msds-text-body-3 xsd-proposals-pdf__card-info">
                                        <div>OS Version please <a href="#osVersion">see information below</a></div>
                                    </div>
                                </div>
                            </div>

                            <div className="col-4 xsd-proposals-pdf__server-setting-col-wrapper">
                                <div className="xsd-proposals-pdf__server-setting-col">
                                    <div className="server-settings__header msds-text-header-3-bold mt-2">Database Storage Information</div>
                                    <div className="msds-text-body-3 xsd-proposals-pdf__card-info mt-2">
                                        <div>Quantity:</div>
                                        <div>{proposalCalculationData?.managementServer?.databaseStorage?.quantity}</div>
                                    </div>
                                    <div className="msds-text-body-3 xsd-proposals-pdf__card-info">
                                        <div>Disk Type: </div>
                                        <div>{proposalCalculationData?.managementServer?.databaseStorage?.diskType}</div>
                                    </div>
                                    <div className="msds-text-body-3 xsd-proposals-pdf__card-info">
                                        <div>Disk Size: </div>
                                        <div>{proposalCalculationData?.managementServer?.databaseStorage?.diskSize}</div>
                                    </div>
                                    <div className="msds-text-body-3 xsd-proposals-pdf__card-info">
                                        <div>Raid Type: </div>
                                        <div>{proposalCalculationData?.managementServer?.databaseStorage?.raidType}</div>
                                    </div>
                                    <div className="msds-text-body-3 xsd-proposals-pdf__card-info">
                                        <div>SQL Edition: </div>
                                        <div>{proposalCalculationData?.managementServer?.sqlServer}</div>
                                    </div>
                                    <div className="msds-text-body-3 xsd-proposals-pdf__card-info">
                                        <div>Supported SQL version and configuration please <a href="#sqlInformation">see information below</a></div>
                                    </div>
                                </div>
                            </div>
                            <div className='xsd-proposals-pdf__divider mt-4'></div>
                        </div>
                    )}
                </div>
            )}
        </>
    )
}
interface IProps {
    proposals: ProposalsProps
}

export default ProposalManagementPdf